module.exports = __webpack_public_path__ + "img/UI_common_framelabelBYB_02_7604db9fd.png";